/* eslint-disable react/require-default-props */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SelectionControlBase } from '../selection-control/SelectionControlBase';
import { CheckboxChecked } from '../private/icons/CheckboxChecked';
import { CheckboxUnchecked } from '../private/icons/CheckboxUnchecked';
import { CheckboxIndeterminate } from '../private/icons/CheckboxIndeterminate';

const IndeterminateIcon = ({ disabled, spanClasses }) => (
  <span className={`${spanClasses} ${ disabled ? 'sui-text-[#FDD8C0]' : 'sui-text-brand' }`}>
    <CheckboxIndeterminate size="inherit" className="sui-bg-primary" />
  </span>
);

IndeterminateIcon.propTypes = {
  disabled: PropTypes.bool,
  spanClasses: PropTypes.string
};

const CheckedIcon = ({ disabled, spanClasses }) => (
  <span className={`${spanClasses} ${ disabled ? 'sui-text-[#FDD8C0]' : 'sui-text-brand' }`}>
    <CheckboxChecked size="inherit" className="sui-bg-primary" />
  </span>
);

CheckedIcon.propTypes = {
  disabled: PropTypes.bool,
  spanClasses: PropTypes.string
};

const UncheckedIcon = ({ disabled, spanClasses }) => (
  <span className={`${spanClasses} ${ disabled ? 'sui-text-inactive' : 'sui-text-subtle' }`}>
    <CheckboxUnchecked size="inherit" className={disabled ? 'sui-bg-inactive' : 'sui-bg-primary'} />
  </span>
);

UncheckedIcon.propTypes = {
  disabled: PropTypes.bool,
  spanClasses: PropTypes.string
};

const Checkbox = (props) => {
  const {
    className,
    disabled,
    ...other
  } = props;

  const spanClasses = classNames('sui-inline-flex sui-align-center sui-justify-center sui-relative sui-box-border sui-bg-transparent sui-align-middle sui-outline-0 sui-border-0 sui-m-0 sui-select-none sui-appearance-none sui-no-underline sui-p-1', {
    'sui-cursor-pointer': !disabled,
    'sui-cursor-default sui-pointer-events-none': disabled
  });

  const classes = {
    span: spanClasses,
    input: 'sui-peer sui-cursor-[inherit] sui-absolute sui-opacity-0 sui-w-full sui-h-full sui-top-0 sui-left-0 sui-m-0 sui-p-0 sui-z-[1]'
  };

  const iconSpanClasses = 'sui-relative sui-flex sui-p-1 sui-bg-transparent peer-hover:sui-bg-brand-subtle peer-focus-visible:sui-text-[#121111] peer-focus-visible:sui-bg-warning sui-text-xl';

  let checkedIcon;
  let uncheckedIcon;

  // eslint-disable-next-line react/destructuring-assignment
  if (props.indeterminate) {
    checkedIcon = <IndeterminateIcon disabled={disabled} spanClasses={iconSpanClasses} />;
    uncheckedIcon = <IndeterminateIcon disabled={disabled} spanClasses={iconSpanClasses} />;
  } else {
    checkedIcon = <CheckedIcon disabled={disabled} spanClasses={iconSpanClasses} />;
    uncheckedIcon = <UncheckedIcon disabled={disabled} spanClasses={iconSpanClasses} />;
  }

  return (
    <SelectionControlBase
      type="checkbox"
      classes={classes}
      disabled={disabled}
      checkedIcon={checkedIcon}
      uncheckedIcon={uncheckedIcon}
      {...other}
    />
  );
};

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  indeterminate: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  inputAttributes: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string
};

Checkbox.defaultProps = {
  checked: undefined,
  className: null,
  defaultChecked: false,
  id: null,
  indeterminate: null,
  inputAttributes: null,
  disabled: undefined,
  onChange: null,
  value: undefined
};

export { Checkbox };
